import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {UpdateRegistrationPage} from './update-registration';

@NgModule({
  declarations: [
    UpdateRegistrationPage,
  ],
  imports: [
    IonicPageModule.forChild(UpdateRegistrationPage),
  ],
  exports: [
    UpdateRegistrationPage
  ]
})
export class UpdateRegistrationPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/update-registration/update-registration.module.ts